import { useTranslation } from "react-i18next"
import Skeleton from "react-loading-skeleton"

import { UnauthenticatedPageLayout } from "@/components/layouts/UnauthenticatedPageLayout"
import { useAppContext } from "@/contexts/app-context"
import { useCollection } from "@/hooks/resources"
import ProductPrice from "@/types/product-price"
import { SelectMembershipForm } from "@/components/forms/select-membership-form"
import UserType from "@/types/user-type"

const SelectMembershipPage = () => {
  const { t } = useTranslation("select-membership-page")
  const { state: { currentUser, isLoadingCurrentUser } } = useAppContext()

  const [availableProductPrices, { isLoading: isLoadingAvailableProductPrices }] =
    useCollection<ProductPrice>("/products/prices")

  return (
    <UnauthenticatedPageLayout
      title={t("pageTitle")}
      className="flex flex-wrap gap-4 justify-center items-center py-8 w-full"
    >
      {
        isLoadingAvailableProductPrices || isLoadingCurrentUser ? [...Array(2)].map((_, index) => (
          <div
            key={index}
            className={`bg-white rounded-2xl border-4 w-[320px] pb-4 flex flex-col gap-4 items-center overflow-clip`}
          >
            <Skeleton
              borderRadius={0}
              containerClassName="w-full leading-none"
              className="h-12 w-full"
            />

            <div className="flex flex-col gap-4 px-4 items-center w-full">
              <Skeleton
                containerClassName="w-3/4 leading-none"
                className="h-8"
              />

              <Skeleton
                containerClassName="w-5/6"
                className="h-4"
                count={5}
              />

              <Skeleton
                containerClassName="w-full leading-none"
                className="h-11"
              />

              <Skeleton
                containerClassName="w-1/2 leading-none"
                className="h-6"
              />
            </div>
          </div>
        )) : (availableProductPrices || []).map(productPrice => {
          return <SelectMembershipForm key={productPrice.lookupKey} productPrice={productPrice} currentUser={currentUser as UserType} />
        })
      }
    </UnauthenticatedPageLayout>
  )
}

export default SelectMembershipPage
